<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="page-contents">
  <div id='levelOne' class="blockContainer flexbox-style-one">
    <div class="h-100">
      <div class="breadcrumbWrapper">
        <!-- {{title}} -->
        <app-breadcrumb></app-breadcrumb>
      </div>

      <div class="combination-loader" [class.studio-container]="isShowEditor">
        <div class="page-list-container float-left">
          <!-- <i class="material-icons float-right color-808080" [routerLink]="['/']">close</i> -->
         
          <child-header title="Pages" [showAdd]="true" titleAdd="Add Page" (addEvent)="onAddNewCms()" (closeEvent)="navigateTo('/admin')"></child-header>

          <loading-screen *ngIf="loadContent" [isScrolled]="true" [showBlurTable]="false" backDropWidth="320"
            ></loading-screen>
          <!-- <div style="padding: 0px 22px 17px 22px">
            <input type="text" class="form-control cms-page-search" placeholder="Search" onfocus="this.placeholder=''" onblur="this.placeholder='Search'" #filterInput
              (change)="filterCms(filterInput.value)">
          </div> -->

          <div class="searchWrapper">
            <div class="searchInputGroup">
              <div class="searchIcon">
                <img src="../images/new_ui/searchIcon-gray.png">
              </div>
              <input type="text" class="searchInput" placeholder="Search" onfocus="this.placeholder=''"
                onblur="this.placeholder='Search'" #filterInput (input)="filterCms(filterInput.value)">
            </div>
          </div>
          <div class="cms-page-height">
            <ul class="cms-page-list">
              <ng-container *ngFor="let cl of cmsList;let clindex = index">
                <ng-container *ngIf="!cl.isOnlySubPage">
                  <li [class.active]="cl._id == newCms._id">
                    <span *ngIf="cl?.subPages && cl?.subPages.length > 0" class="float-left">
                      <img src="images/cms-icons/arrow-right.svg" *ngIf="!cl.isShowSubpages"
                        (click)="cl.isShowSubpages = true" class="arrowIcon">
                      <img src="images/cms-icons/down-arrow.svg" *ngIf="cl.isShowSubpages"
                        (click)="cl.isShowSubpages = false" class="arrowIcon">
                      &#160;
                    </span>
                    <span class="page-list-title"
                      (click)="newCms = cl; isSubPageSelected = false; subPageParentCms = null; isShowEditor = true;"
                      [class.active-txt]="newCms._id == cl._id && isSubPageSelected == false"
                      [attr.data-toggle]="cl?.title" title="{{cl?.title}}">{{cl?.title}}
                      <ng-container *ngIf="cl?.subPages">({{cl?.subPages.length}})</ng-container>
                      <ng-container *ngIf="!cl?.subPages">(0)</ng-container>
                    </span>
                    <!-- <span class="float-right">
                      <img src="images/cms-icons/plus.svg" style="height: 11px" class="cursor-pointer"
                         > -->
                    <!-- &#160;<img src="images/cms-icons/delete.svg" (click)="deleteCms(cl._id)" class="cursor-pointer" style="height: 11px"> -->
                    <!-- </span> -->
                    <div class="basic-icon add-icon small-add-icon-position float-right"
                      (click)="selectedCms = cl; newCms = cl; openAddPageModal(); addNewCms(); isShowEditor = true;">
                    </div>
                    <div *ngIf="cl?.isShowSubpages && cl?.subPages" [dragula]="'DRGULA_CONTAINER'" [dragulaModel]="cl.subPages"
                      (dragulaModelChange)="dragulaChangeEvent($event, cl._id)">
                      <div *ngFor="let sp of cl?.subPages; let subpageIndex = index;trackBy:trackByIdx">
                        <div class="sub-title-padding"
                          (click)="getCmsById(sp._id, cl?.owners, cl?.contributors); isSubPageSelected = true; subPageParentCms = cl; isShowEditor = true;"
                          [class.active-txt]="newCms._id == sp._id && isSubPageSelected == true"
                          [class.color-inhert]="!isSubPageSelected" [attr.data-toggle]="sp?.title"
                          title="{{sp?.title}}">
                          {{sp?.title}}
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </li>
                </ng-container>
              </ng-container>
            </ul>
          </div>
        </div>
        <div *ngIf="isShowEditor" class="float-left studio-content-container">
          <child-header (closeEvent)="isShowEditor = false"></child-header>
          <div style="padding: 22px;">
            <form #cmsForm="ngForm">
              <div class="row">
                <div class="form-group col-md-8">
                  <label class="control-label w-100">
                    Title *
                    <span [hidden]="cmstitlemodel.valid || !isSubmitForm">
                      <span class="text-danger float-right" [hidden]="!cmstitlemodel.hasError('required')">Required</span>
                    </span>
                  </label>
                  <input type="text" class="form-control" name="title" [(ngModel)]="newCms.title" required
                    #cmstitlemodel="ngModel"
                    [disabled]="newCms._id && (!getPermission(newCms, 'owner') && !getPermission(newCms, 'contr'))">
                </div>
                <div class="form-group col-md-4 p-0">
                  <label class="control-label w-100">Id</label>
                  <input type="text" class="form-control calc-width" name="id" [(ngModel)]="newCms._id" disabled>
                  <i class="material-icons cursor-pointer" ngxClipboard [cbContent]="newCms?._id"
                    (click)="copyLink()">file_copy</i>
                </div>
              </div>
              <div #froalaEditorDiv class="form-group">
                <!-- <label class="control-label w-100">Template</label> -->
                <textarea
                  *ngIf="!newCms._id || (newCms._id && (getPermission(newCms, 'owner') || getPermission(newCms, 'contr')))"
                  name="innerHtml" [froalaEditor]="froalaOptions" [(froalaModel)]="newCms.innerHtml"></textarea>
                <div *ngIf="newCms._id && !getPermission(newCms, 'owner') && !getPermission(newCms, 'contr')"
                  [innerHTML]="newCms.innerHtml | sanitizeHtml" class="cms-size"></div>
              </div>
              <div class="form-group text-right">
                <span class="text-center font-x12">{{postMsg}}</span>&#160;
                <button *ngIf="newCms?._id" type="button" class="button button-red button-mid" ngxClipboard
                  [cbContent]="getTemplateLink(newCms?._id)" (click)="copyLink()">Copy Link
                </button>
                <button *ngIf="newCms?._id && getPermission(newCms, 'owner')" type="button"
                  class="button button-red button-mid" (click)="deleteCmsRoot()">Delete</button>
                <button *ngIf="!newCms?._id || getPermission(newCms, 'owner') || getPermission(newCms, 'contr')"
                  type="button" class="button button-red button-mid" (click)="createOrUpdateCms(cmsForm)"
                  [disabled]="isDisableSubmit">Save</button>
              </div>
            </form>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</div>

<ng-template #addPageModal let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Add Page</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="search-container float-left">
      <div class="search-header-container">
        <div class="search-result-container">
          <ul class="font-x12">
            <ng-container *ngFor="let tl of templateList">
              <li (click)="selectedTemplate = tl" class="cursor-pointer"
                [class.active]="selectedTemplate.innerHtml == tl.innerHtml">{{tl.name}}</li>
            </ng-container>
            <li [class.active]="selectedTemplate.innerHtml == null" class="cursor-pointer"
              (click)="newSelectedTemplate()">Blank</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="search-view-template">
      <div *ngIf="selectedTemplate?.innerHtml" [innerHTML]="selectedTemplate?.innerHtml | sanitizeHtml"></div>
    </div>

    <div class="modal-footer text-right">
      <div class="w-100">
        <button class="button button-red button-mid"
          (click)="newCms.innerHtml = selectedTemplate.innerHtml;d('Cross click')">
          Select
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #linkExistingTemplateModal let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Insert Link</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="search-container float-left">
      <div class="search-header-container">
        <div class="form-group p-2">
          <input type="text" class="form-control cms-page-search w-100" #searchInput
            (keydown.enter)="searchTemplate(searchInput.value)" placeholder="Search" onfocus="this.placeholder=''"
            onblur="this.placeholder='Search'">
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="search-result-container">
        <div class="font-x12 padding-x10" *ngIf="isLoadingSearchTemplate">Loading... </div>
        <ul class="font-x12">
          <ng-container *ngIf="searchTemplateList?.length > 0">
            <ng-container *ngFor="let tmp of searchTemplateList">
              <li *ngIf="tmp.isActive" [class.active]="selectedSearchTemplate?._id == tmp?._id"
                (click)="selectedSearchTemplate = tmp">{{tmp?.title}}</li>
            </ng-container>
          </ng-container>
          <ng-container
            *ngIf="searchTemplateList?.length == 0 && searchInput?.value != null && !isLoadingSearchTemplate">
            <div class="padding-x10">No template found!</div>
          </ng-container>
        </ul>
      </div>
    </div>

    <div class="search-view-template search-view-height">
      <span [innerHtml]="selectedSearchTemplate?.innerHtml | sanitizeHtml"></span>
    </div>

    <div class="modal-footer">
      <div class="w-100">
        <input type="text" name="insertTemplateName" [(ngModel)]="insertTemplateName"
          class="form-control float-left insert-link-name" placeholder="Insert link name" onfocus="this.placeholder=''"
          onblur="this.placeholder='Insert link name'">
        <button class="button button-red button-mid" (click)="cmsTemplateInsert();d('Cross click')"
          [disabled]="!insertTemplateName"> Insert</button>
      </div>
    </div>
  </div>
</ng-template>
<button class="btn btn-outline-primary mb-2 mr-2 hidden" style="display: none;" #openModalButton
  (click)="openLinkExistingTemplateModal(linkExistingTemplateModal)">Open</button>